/* ============================================
   Folk Objects - Trade Account Login (OTP)
   Vanilla JS – Shopify-compatible
   ============================================ */

(function () {
  'use strict';

  let resendTimer = null;
  let loginEmail = '';
  let isSending = false;
  let isVerifying = false;

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  document.addEventListener('DOMContentLoaded', init);

  const RETURN_URL_KEY = 'folk_return_url';

  function getReturnUrl() {
    try { return localStorage.getItem(RETURN_URL_KEY) || '/'; } catch (e) { return '/'; }
  }
  function clearReturnUrl() {
    try { localStorage.removeItem(RETURN_URL_KEY); } catch (e) {}
  }

  function init() {
    // If already logged in, redirect to return URL or account
    if (window.FolkAPI && FolkAPI.getToken()) {
      var dest = getReturnUrl();
      clearReturnUrl();
      window.location.href = dest;
      return;
    }
    setupEmailScreen();
    setupOtpInputs();
    setupOtpActions();
  }

  function showScreen(name) {
    $$('.folk-screen').forEach(s => s.classList.remove('active'));
    const el = $(`#folk-login-${name}`);
    if (el) {
      void el.offsetWidth;
      el.classList.add('active');
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ---- Email screen ----
  function setupEmailScreen() {
    const input = $('#folk-login-email-input');
    const btn = $('#folk-send-otp');

    if (input) {
      input.addEventListener('blur', () => validateEmail(input));
      input.addEventListener('input', () => {
        input.classList.remove('invalid');
        const hint = input.closest('.folk-form-group').querySelector('.folk-field-hint');
        if (hint) hint.textContent = '';
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); btn && btn.click(); }
      });
    }

    if (btn) {
      btn.addEventListener('click', async () => {
        if (!validateEmail(input) || isSending) return;
        loginEmail = input.value.trim();
        isSending = true;
        const originalText = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = 'Sending...';
        try {
          await FolkAPI.loginRequest(loginEmail);
          showOtpScreen();
        } catch (err) {
          if (err.status === 404) {
            showNoAccountPopup();
          } else {
            showInputError(input, err.message || 'Could not send OTP');
          }
        } finally {
          isSending = false;
          btn.disabled = false;
          btn.innerHTML = originalText;
        }
      });
    }
  }

  function showInputError(input, msg) {
    const hint = input.closest('.folk-form-group').querySelector('.folk-field-hint');
    if (hint) hint.textContent = msg;
    input.classList.add('invalid');
  }

  function validateEmail(input) {
    const val = (input.value || '').trim();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
    const hint = input.closest('.folk-form-group').querySelector('.folk-field-hint');

    const wrap = input.closest('.folk-input-wrap');
    let icon = wrap.querySelector('.folk-input-icon');
    if (!icon) {
      icon = document.createElement('span');
      icon.className = 'folk-input-icon';
      wrap.appendChild(icon);
    }

    if (val.length === 0) {
      icon.textContent = '';
      icon.className = 'folk-input-icon';
      input.classList.remove('valid', 'invalid');
      if (hint) hint.textContent = 'This field is required';
      return false;
    }

    if (valid) {
      icon.textContent = '\u2713';
      icon.className = 'folk-input-icon valid';
      input.classList.remove('invalid');
      input.classList.add('valid');
      if (hint) hint.textContent = '';
    } else {
      icon.textContent = '\u2717';
      icon.className = 'folk-input-icon invalid';
      input.classList.add('invalid');
      input.classList.remove('valid');
      if (hint) hint.textContent = 'Please enter a valid email';
    }
    return valid;
  }

  // ---- OTP screen ----
  function showOtpScreen() {
    const display = $('#folk-login-otp-email');
    if (display) display.textContent = loginEmail;

    $$('#folk-login-otp .folk-otp-box').forEach(b => {
      b.value = '';
      b.classList.remove('filled', 'error');
    });
    const err = $('#folk-login-otp-error');
    if (err) err.classList.add('folk-hidden');

    showScreen('otp');
    startResendTimer();

    const firstBox = $('#folk-login-otp .folk-otp-box');
    if (firstBox) setTimeout(() => firstBox.focus(), 350);
  }

  function setupOtpInputs() {
    const boxes = $$('#folk-login-otp .folk-otp-box');
    boxes.forEach((box, i) => {
      box.addEventListener('input', () => {
        const val = box.value.replace(/[^0-9]/g, '');
        box.value = val;
        boxes.forEach(b => b.classList.remove('error'));
        const err = $('#folk-login-otp-error');
        if (err) err.classList.add('folk-hidden');
        if (val && i < boxes.length - 1) boxes[i + 1].focus();
        box.classList.toggle('filled', val.length > 0);
        maybeAutoVerify();
      });

      box.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace' && !box.value && i > 0) {
          boxes[i - 1].focus();
          boxes[i - 1].value = '';
          boxes[i - 1].classList.remove('filled');
        }
        if (e.key === 'Enter') verifyOtp();
      });

      box.addEventListener('paste', (e) => {
        e.preventDefault();
        const pasted = (e.clipboardData.getData('text') || '').replace(/[^0-9]/g, '');
        for (let j = 0; j < boxes.length; j++) {
          boxes[j].value = pasted[j] || '';
          boxes[j].classList.toggle('filled', !!pasted[j]);
        }
        boxes[Math.min(pasted.length, boxes.length - 1)].focus();
        maybeAutoVerify();
      });
    });
  }

  // Fires verifyOtp() as soon as all 4 boxes have a digit. Guarded against
  // re-entry by the existing `isVerifying` flag inside verifyOtp().
  function maybeAutoVerify() {
    if (getEnteredOtp().length === 4 && !isVerifying) {
      verifyOtp();
    }
  }

  function setupOtpActions() {
    const verifyBtn = $('#folk-login-verify');
    if (verifyBtn) verifyBtn.addEventListener('click', verifyOtp);

    const resendBtn = $('#folk-login-resend');
    if (resendBtn) resendBtn.addEventListener('click', resendOtp);

    const backBtn = $('#folk-login-back');
    if (backBtn) backBtn.addEventListener('click', () => showScreen('email'));
  }

  function getEnteredOtp() {
    return $$('#folk-login-otp .folk-otp-box').map(b => b.value).join('');
  }

  async function verifyOtp() {
    if (isVerifying) return;
    const entered = getEnteredOtp();
    const boxes = $$('#folk-login-otp .folk-otp-box');
    const errEl = $('#folk-login-otp-error');

    if (entered.length < 4) {
      boxes.forEach(b => { if (!b.value) b.classList.add('error'); });
      return;
    }

    isVerifying = true;
    const btn = $('#folk-login-verify');
    const originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Verifying...'; }

    try {
      const data = await FolkAPI.verify(loginEmail, entered, 'login');
      FolkAPI.setToken(data.token);
      FolkAPI.setUser(data.user);
      if (resendTimer) clearInterval(resendTimer);
      showScreen('success');
      var dest = getReturnUrl(); clearReturnUrl();
      setTimeout(() => { window.location.href = dest; }, 1200);
    } catch (err) {
      boxes.forEach(b => { b.classList.add('error'); b.classList.remove('filled'); });
      if (errEl) {
        errEl.textContent = err.message || 'Invalid code. Please try again.';
        errEl.classList.remove('folk-hidden');
      }
    } finally {
      isVerifying = false;
      if (btn) { btn.disabled = false; btn.textContent = originalText || 'Verify'; }
    }
  }

  function startResendTimer() {
    if (resendTimer) clearInterval(resendTimer);
    let seconds = 30;
    const btn = $('#folk-login-resend');
    const span = $('#folk-login-timer');
    if (!btn || !span) return;

    btn.disabled = true;
    span.textContent = `(${seconds}s)`;

    resendTimer = setInterval(() => {
      seconds--;
      span.textContent = `(${seconds}s)`;
      if (seconds <= 0) {
        clearInterval(resendTimer);
        resendTimer = null;
        btn.disabled = false;
        span.textContent = '';
      }
    }, 1000);
  }

  async function resendOtp() {
    $$('#folk-login-otp .folk-otp-box').forEach(b => {
      b.value = '';
      b.classList.remove('filled', 'error');
    });
    const err = $('#folk-login-otp-error');
    if (err) err.classList.add('folk-hidden');

    try {
      await FolkAPI.loginRequest(loginEmail);
      startResendTimer();
      const firstBox = $('#folk-login-otp .folk-otp-box');
      if (firstBox) firstBox.focus();
    } catch (e) {
      if (err) {
        err.textContent = e.message || 'Could not resend code';
        err.classList.remove('folk-hidden');
      }
    }
  }

  function showNoAccountPopup() {
    if ($('#folk-no-account-modal')) return;
    const overlay = document.createElement('div');
    overlay.id = 'folk-no-account-modal';
    overlay.innerHTML = `
      <style>
        #folk-no-account-modal {
          position: fixed; inset: 0; background: rgba(0,0,0,.5);
          display: flex; align-items: center; justify-content: center;
          z-index: 9999; animation: folkFadeIn .15s ease;
        }
        #folk-no-account-modal .folk-modal-box {
          background: #fff; border-radius: 12px; padding: 32px;
          max-width: 400px; width: 90%; text-align: center;
          box-shadow: 0 20px 60px rgba(0,0,0,.2);
          font-family: inherit;
        }
        #folk-no-account-modal h3 { margin: 0 0 8px; font-size: 18px; font-weight: 600; }
        #folk-no-account-modal p { margin: 0 0 24px; color: #666; font-size: 14px; line-height: 1.5; }
        #folk-no-account-modal .folk-modal-actions { display: flex; gap: 12px; justify-content: center; }
        #folk-no-account-modal button, #folk-no-account-modal a {
          padding: 12px 22px; border-radius: 8px; font-size: 14px;
          font-weight: 500; cursor: pointer; border: 1px solid #ddd;
          text-decoration: none; display: inline-block; text-align: center;
          min-width: 120px;
        }
        #folk-no-account-modal button { background: #fff; color: #1a1a1a; }
        #folk-no-account-modal a {
          background: var(--folk-primary-hover, #5a3023); color: #fff; border-color: var(--folk-primary-hover, #5a3023);
        }
        @keyframes folkFadeIn { from { opacity: 0 } to { opacity: 1 } }
      </style>
      <div class="folk-modal-box" role="dialog" aria-modal="true">
        <h3>No account found</h3>
        <p>There's no trade account linked to this email.<br>Would you like to create one?</p>
        <div class="folk-modal-actions">
          <button type="button" data-action="cancel">Use Different Email</button>
          <a href="/pages/trade-signup" data-action="signup">Create Account</a>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    const close = () => overlay.remove();
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
      if (e.target.dataset.action === 'cancel') close();
    });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
    });
  }

})();
